"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Header = ({ row, removableCells }) => (react_1.default.createElement("div", { className: 'table-header' },
    row.map((heading, index) => (react_1.default.createElement("div", { className: 'table-header-cell', key: index },
        heading.text,
        heading.tooltip && heading.tooltip))),
    removableCells && react_1.default.createElement("div", { className: 'remove-cell-header' }, "Remove")));
exports.default = Header;
